import Analytics from '@app/analytics/client-analytics/event-analytics'
import {EventKey} from '@app/analytics/constants'
import {adEventKey, adField} from '@app/components/ads/hooks/use-ad-event'

export const triggerAdFailedEvent = (
  adSpot: string,
  adDemandSource: string,
  size: string,
  isGameplayerPage = false,
  gameCode?: string,
  gameName?: string,
) => {
  new Analytics({
    name: adEventKey.adFailed,
    data: {
      [adField.adDemandSource]: adDemandSource,
      [adField.adSpot]: adSpot,
      [adField.adSizesRequested]: size,
      ...(isGameplayerPage && {[EventKey.gameName]: gameName}),
      ...(isGameplayerPage && {[EventKey.gameCode]: gameCode}),
    },
  }).dispatch()
}

export const triggerAdDismissedEvent = (
  adSpot: string,
  adDemandSource: string,
  size: string,
  isGameplayerPage = false,
  gameCode?: string,
  gameName?: string,
) => {
  new Analytics({
    name: adEventKey.adDismissed,
    data: {
      [adField.adDemandSource]: adDemandSource,
      [adField.adSpot]: adSpot,
      [adField.adSizesRequested]: size,
      ...(isGameplayerPage && {[EventKey.gameName]: gameName}),
      ...(isGameplayerPage && {[EventKey.gameCode]: gameCode}),
    },
  }).dispatch()
}

export const triggerAdRequestedEvent = (
  adSpot: string,
  adDemandSource: string,
  size: string,
  isGameplayerPage = false,
  gameCode?: string,
  gameName?: string,
) => {
  new Analytics({
    name: adEventKey.adRequested,
    data: {
      [adField.adDemandSource]: adDemandSource,
      [adField.adSpot]: adSpot,
      [adField.adSizesRequested]: size,
      ...(isGameplayerPage && {[EventKey.gameName]: gameName}),
      ...(isGameplayerPage && {[EventKey.gameCode]: gameCode}),
    },
  }).asyncDispatch()
}

export const triggerAdLoadedEvent = (
  adSpot: string,
  adDemandSource: string,
  size: string,
  isGameplayerPage = false,
  gameCode?: string,
  gameName?: string,
) => {
  new Analytics({
    name: adEventKey.adLoaded,
    data: {
      [adField.adDemandSource]: adDemandSource,
      [adField.adSpot]: adSpot,
      [adField.adSizesRequested]: size,
      ...(isGameplayerPage && {[EventKey.gameName]: gameName}),
      ...(isGameplayerPage && {[EventKey.gameCode]: gameCode}),
    },
  }).dispatch()
}

export const triggerAdViewedEvent = (
  adSpot: string,
  adDemandSource: string,
  size: string,
  isGameplayerPage = false,
  gameCode?: string,
  gameName?: string,
) => {
  new Analytics({
    name: adEventKey.adViewed,
    data: {
      [adField.adDemandSource]: adDemandSource,
      [adField.adSpot]: adSpot,
      [adField.adSizesRequested]: size,
      ...(isGameplayerPage && {[EventKey.gameName]: gameName}),
      ...(isGameplayerPage && {[EventKey.gameCode]: gameCode}),
    },
  }).dispatch()
}

export const triggerAdDelayedEvent = (
  adSpot: string,
  adDemandSource: string,
  size: string,
  isGameplayerPage = false,
  gameCode?: string,
  gameName?: string,
) => {
  new Analytics({
    name: adEventKey.adDelayed,
    data: {
      [adField.adDemandSource]: adDemandSource,
      [adField.adSpot]: adSpot,
      [adField.adSizesRequested]: size,
      ...(isGameplayerPage && {[EventKey.gameName]: gameName}),
      ...(isGameplayerPage && {[EventKey.gameCode]: gameCode}),
    },
  }).dispatch()
}

export const triggerAdClosedEvent = (
  adSpot: string,
  adDemandSource: string,
  size: string,
  isGameplayerPage = false,
  gameCode?: string,
  gameName?: string,
) => {
  new Analytics({
    name: adEventKey.adClosed,
    data: {
      [adField.adDemandSource]: adDemandSource,
      [adField.adSpot]: adSpot,
      [adField.adSizesRequested]: size,
      ...(isGameplayerPage && {[EventKey.gameName]: gameName}),
      ...(isGameplayerPage && {[EventKey.gameCode]: gameCode}),
    },
  }).dispatch()
}
